<template>
    <div>
        <div class="px-4 last:pb-2 rounded-2xl shadow-xl" :class="[animate ? 'transition-all ease-in-out group' : '', first ? 'pt-2' : '']">
            <div v-if="!first" class="flex h-[1px] mb-4 w-full"></div>
            <div class="flex flex-row w-full cursor-pointer items-center justify-center" @click="expand">
                <div class="relative w-24 h-24 rounded-md text-white flex items-center justify-center">
                    <img :alt="$translate(data.name)" :src="data.image" class="object-contain" />
                </div>
                <div class="grow pl-2 my-auto flex items-center justify-center">
                    <h4 class="w-full text-base font-semibold">
                        {{ $translate(data.name) }}
                        <!--   <span v-if="showNewTag && data.slug?.name === 'hype-aktien'" class="text-xs text-white bg-blue rounded-md p-1 shadow-md">
                            {{ $t('plain_new').toUpperCase() }}
                        </span> -->
                    </h4>
                </div>
            </div>
            <div class="flex flex-row h-12 w-full">
                <div class="hover:brightness-95 gradient rounded-md py-2 w-1/2 my-auto cursor-pointer" @click="giftSub ? giftSubSelected() : openPopup()">
                    <p class="w-full text-white text-center text-xs">
                        {{ giftSub ? 'Kaufen' : $t('plain_select') }}
                    </p>
                </div>
                <div
                    class="hover:underline underline-offset-2 rounded-md ml-1 py-2 w-1/2 my-auto cursor-pointer shadow-slate-200 transition-all ease-in-out duration-200"
                    :class="expanded ? ' bg-gray-100' : ''"
                    @click="expand"
                >
                    <p class="w-full base-color-text text-center text-xs">
                        {{ giftSub ? 'Varianten' : $t('plain_short_info') }}
                    </p>
                </div>
            </div>
            <div class="info-box flex flex-col w-full rounded-md shadow-slate-200 transition-all ease-out duration-300" :class="expanded ? '' : 'overflow-hidden'">
                <div class="px-3 pt-2 select-text cursor-default">
                    <span class="line-clamp-7 text-xs" v-html="$translate(data.short_description)"></span>
                </div>

                <Select
                    v-model:selected="variant"
                    name="product_variant"
                    :no-value-allowed="false"
                    :form-component-id="$.uid"
                    :options="variants"
                    :multiple="false"
                    class="text-xs py-2 px-3"
                />

                <div v-if="!giftSub" class="col-span-1">
                    <ProductWebinarOption
                        v-if="webinarsBookable"
                        v-model:toggle-selected-webinar="toggleSelectedWebinar"
                        :selected-webinar="selectedWebinar"
                        :data="data"
                        :product-category="productCategory"
                    />
                </div>

                <div class="flex flex-row h-12 w-full px-1">
                    <div
                        class="rounded-md py-2 mx-1 my-auto w-2/3 gradient"
                        :class="isMaintenanceActive ? 'opacity-50 cursor-not-allowed' : 'hover:brightness-95 cursor-pointer'"
                        @click="isMaintenanceActive ? $router.push('/sorry') : (giftSub ? giftSubSelected() : intoCart())"
                    >
                        <p class="w-full text-white text-center text-xs">{{ giftSub ? 'Kaufen' : $t('payment_add_to_cart') }}</p>
                    </div>
                    <router-link :to="'/produkte/' + data.slug?.name">
                        <div class="hover:underline underline-offset-2 py-2 grow my-auto cursor-pointer">
                            <p class="base-color-text w-full text-center text-xs">
                                {{ $t('plain_details') }}
                            </p>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import i18next from 'i18next';
import _ from 'lodash';
import { mapGetters } from 'vuex';
import { toCurrency } from '../../helpers.js';
import Toastification from '../miscellaneous/Toastification.vue';
import ProductWebinarOption from './ProductWebinarOption.vue';

export default {
    components: { ProductWebinarOption },

    props: {
        data: Object,
        productCategory: Object,
        animate: Boolean,
        first: Boolean,
        giftSub: Boolean
    },
    data: () => ({
        expanded: false,
        writtenProduct: null,
        webinarProduct: null,
        productVariantsWritten: null,
        productVariantsWebinars: null,
        selectedProductVariant: null,
        selectedWebinar: null,
        toggleSelectedWebinar: false,
        webinarsBookable: false,
        variant: null,
        loading: false,
        variants: [
            {
                value: '0',
                label: i18next.t('count_month', { count: 1 }),
                runtime: 1
            },
            {
                value: '1',
                label: i18next.t('count_month_plural', { count: 3 }),
                runtime: 3
            },
            {
                value: '2',
                label: i18next.t('count_month_plural', { count: 6 }),
                runtime: 6
            },
            {
                value: '3',
                label: i18next.t('count_month_plural', { count: 12 }),
                runtime: 12
            }
        ],
        showNewTag: true
    }),

    computed: {
        link() {
            return this.getApplicationType() === 'backend' ? '/dashboard/produkte/' + this.productgroup.slug.name : '/produkte/' + this.productgroup.slug.name;
        },
        background() {
            return 'linear-gradient(to bottom, ' + this.productCategory.background_color + ' 0%, ' + this.productCategory.background_gradient + ' 100%)';
        },
        backgroundReverse() {
            return 'linear-gradient(to bottom, ' + this.productCategory.background_gradient + ' 0%, ' + this.productCategory.background_color + ' 100%)';
        },
        toggleInfoBoxHeight() {
            return this.expanded ? 'w-min[200px]' : '0px';
        },
        toggleInfoBoxOpacity() {
            return this.expanded ? 1 : 0;
        },
        ...mapGetters('settings', {
            getApplicationType: 'getApplicationType',
            isMaintenanceActive: 'isMaintenanceActive'
        }),
        ...mapGetters('product_group', {
            getProductGroup: 'get',
            getProduct: 'getProduct',
            getWebinar: 'getWebinar',
            getWebinarVariantByPeriod: 'getWebinarVariantByPeriod',
            getProductAttributesByType: 'getProductAttributesByType'
        })
    },
    watch: {
        toggleSelectedWebinar() {
            this.selectWebinar();
        }
    },

    async mounted() {
        // get written and webinar product separated
        this.data.products.data.forEach((product) => {
            if (product.optional === false) {
                this.writtenProduct = product;
            } else {
                this.webinarProduct = product;
            }
        });

        // get product variants sorted by frequency
        this.productVariantsWritten = this.sortProductVariantsByFrequency(this.writtenProduct.productVariants.data);

        if (this.webinarProduct) {
            this.productVariantsWebinars = this.sortProductVariantsByFrequency(this.webinarProduct.productVariants.data);
        }

        this.webinarsBookable = this.areWebinarsBookable();

        this.selectedProductVariant = _.first(this.productVariantsWritten);

        // generate labels
        if (this.variants.length === this.productVariantsWritten.length) {
            for (let index = 0; index < this.variants.length; index++) {
                const label = this.variants[index].label;

                // get currency and rate
                const currencySymbol = this.$root.$currencyData[this.$getCurrencyCode()]?.symbol || this.$getCurrencyCode();
                const rate = this.$root.$currencyData[this.$getCurrencyCode()]?.rate || 1;

                // const endPrice = (this.productVariantsWritten[index].total_end_price_gross / this.variants[index].runtime) * rate * 100;
                const endPrice = this.productVariantsWritten[index].base_price_gross * (1 - this.productVariantsWritten[index].discount_percent) * 100;

                // create price string
                const price = toCurrency(Math.round(endPrice) / 100);
                // const labelWithPrice = label + ', ' + price + currencySymbol + (index !== 0 ? ` p.m.` : ``);
                this.variants[index].label = `${label}, ${price} ${index !== 0 ? ' p.m.' : ''}`;
            }
        }
    },

    methods: {
        async expand() {
            this.expanded = !this.expanded;

            this.$emit('shrinkOther', this.data.id);
        },
        async openPopup() {
            this.selectedProductVariant = this.productVariantsWritten[this.variant];
            this.selectWebinar();
            this.$emit('openPopup', this.data, this.productCategory, this.variant, this.selectedProductVariant, this.selectedWebinar);
        },
        shrink() {
            this.expanded = false;
        },
        async intoCart() {
            const products = [];
            this.selectedProductVariant = this.productVariantsWritten[this.variant];
            this.selectWebinar();

            if (this.selectedProductVariant) {
                products.push(this.selectedProductVariant);
            }

            if (this.selectedWebinar) {
                products.push(this.selectedWebinar);
            }

            for (const selectedProductVariant of products) {
                await this.$store
                    .dispatch('cart_products/store', {
                        product_variant_id: selectedProductVariant.id
                    })
                    .then((response) => {
                        // if no message in response the product was added succesfully
                        if (!response?.meta?.message) {
                            this.$toast.success({
                                component: Toastification,
                                props: {
                                    message: i18next.t('succesfully_added_to_cart'),
                                    type: 'success'
                                }
                            });
                        } else {
                            this.$toast.info({
                                component: Toastification,
                                props: {
                                    message: response?.meta?.message.info
                                        ? response?.meta?.message.info
                                        : response?.meta?.message.danger
                                          ? response?.meta?.message.danger
                                          : wTrans('Action failed'),
                                    type: 'info'
                                }
                            });
                        }
                    });
            }

            this.$store.dispatch('cart/index');
        },
        sortProductVariantsByFrequency(productVariants) {
            productVariants = _.sortBy(productVariants, (productVariant) => {
                const productAttributeValue = productVariant.productAttributeValues.data.find((productAttributeValue) => {
                    return productAttributeValue.meta.type === 'period';
                });

                return productAttributeValue.meta.runtime_in_days;
            });

            return productVariants;
        },
        selectWebinar() {
            this.toggleSelectedWebinar && this.productVariantsWebinars ? (this.selectedWebinar = this.productVariantsWebinars[this.variant]) : (this.selectedWebinar = null);
        },
        areWebinarsBookable() {
            if (this.productVariantsWebinars) {
                return this.productVariantsWebinars.length > 0;
            } else {
                return false;
            }
        },
        giftSubSelected() {
            // Emit event to parent component
            const products = [];
            this.selectedProductVariant = this.productVariantsWritten[this.variant];
            this.selectWebinar();

            if (this.selectedProductVariant) {
                products.push(this.selectedProductVariant);
            }

            if (this.selectedWebinar) {
                products.push(this.selectedWebinar);
            }

            this.$emit('giftSubSelected', products);
        }
    }
};
</script>

<style scoped>
.link {
    color: v-bind(backgroundColor);
}
.gradient {
    background: v-bind(background);
}
.gradient-reverse {
    background: v-bind(backgroundReverse);
}
.base-color-text {
    color: v-bind(backgroundColor);
    opacity: 0.7;
}
.info-box {
    height: v-bind(toggleInfoBoxHeight);
    opacity: v-bind(toggleInfoBoxOpacity);
}
</style>
